import { Accordion, AccordionButton, AccordionItem, AccordionPanel, Flex } from '@chakra-ui/react';
import { useContentAsset } from '../../../../../../bff-api/content/useContentAsset';
import { ContentAssetID } from '../../../../../../utils/api/ContentAssetID';
import { sanitizeHtml } from '../../../../../content-asset/sanitize-html';
import { ExpandIcon } from '../ExpandIcon';
import styles from '../MenuCategoryMobile.module.scss';

export const MenuCategoryBrandsMobile: React.FC = () => {
    const { data: brandsAE } = useContentAsset(ContentAssetID.BRANDS_A_E);
    const { data: brandsFJ } = useContentAsset(ContentAssetID.BRANDS_F_J);
    const { data: brandsKO } = useContentAsset(ContentAssetID.BRANDS_K_O);
    const { data: brandsPT } = useContentAsset(ContentAssetID.BRANDS_P_T);
    const { data: brandsU123 } = useContentAsset(ContentAssetID.BRANDS_U_123);

    return (
        <Accordion allowToggle variant="slt-mobile" className={styles.menu_brands}>
            <BrandAccordionItem label="A-E" html={brandsAE?.html ?? ''} />

            <BrandAccordionItem label="F-J" html={brandsFJ?.html ?? ''} />

            <BrandAccordionItem label="K-O" html={brandsKO?.html ?? ''} />

            <BrandAccordionItem label="P-T" html={brandsPT?.html ?? ''} />

            <BrandAccordionItem label="U-123" html={brandsU123?.html ?? ''} />
        </Accordion>
    );
};

const BrandAccordionItem = ({
    label,
    html,
}: {
    label: string;
    html: string;
}): JSX.Element | null =>
    html ? (
        <AccordionItem data-testid={`header.menu.mobile.category.brands.${label.toLowerCase()}`}>
            {({ isExpanded }): React.ReactElement => (
                <>
                    <Flex
                        data-testid={`header.menu.mobile.category.brands.${label.toLowerCase()}.title`}
                        role="heading"
                        alignItems="center"
                        cursor="pointer"
                        marginX={4}
                        marginY={3}
                    >
                        <AccordionButton>{label}</AccordionButton>

                        <ExpandIcon id={label.toLowerCase()} isExpanded={isExpanded} />
                    </Flex>

                    <AccordionPanel background="slt-black.50">
                        <Flex
                            data-testid={`header.menu.mobile.category.brands.${label.toLowerCase()}.content`}
                            dangerouslySetInnerHTML={{
                                __html: sanitizeHtml(html),
                            }}
                        />
                    </AccordionPanel>
                </>
            )}
        </AccordionItem>
    ) : null;
